<div class="row login-container">
  <div class="col-6 form-section">
    <img src="assets/png/broadfactorLogo.png" alt="Broadfactor Logo" class="logo" />
    <form [formGroup]="loginForm" class="form-content">
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input
          matInput
          placeholder="exemplo@exemplo"
          formControlName="userName"
          required
          data-cy="login-email-input" />
        <mat-error data-cy="login-email-input-errors">
          @if (
            loginForm.get("userName")?.hasError("required") && loginForm.get("userName")?.touched
          ) {
            O campo e-mail é obrigatório.
          } @else if (
            loginForm.get("userName")?.hasError("email") && loginForm.get("userName")?.dirty
          ) {
            O e-mail inserido não é válido.
          }
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Senha</mat-label>
        <input
          matInput
          [type]="hide() ? 'password' : 'text'"
          formControlName="password"
          data-cy="login-password-input" />
        <mat-error data-cy="login-password-input-errors">
          @if (
            loginForm.get("password")?.hasError("required") && loginForm.get("password")?.touched
          ) {
            O campo senha é obrigatório.
          } @else if (
            loginForm.get("password")?.hasError("minlength") && loginForm.get("password")?.dirty
          ) {
            A senha deve ter no mínimo 8 caracteres.
          }
        </mat-error>
        <button
          mat-icon-button
          matSuffix
          (click)="handleHidePassword($event)"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide()">
          <mat-icon>{{ hide() ? "visibility_off" : "visibility" }}</mat-icon>
        </button>
      </mat-form-field>
      <button
        mat-button
        type="submit"
        class="btn-primary"
        [disabled]="!loginForm.valid"
        (click)="onSubmit()"
        data-cy="login-button">
        @if (isLoading()) {
          <mat-spinner diameter="24"></mat-spinner>
        } @else {
          Entrar
        }
      </button>
      <div class="forgot-password" data-cy="forgot-password-link">
        <a role="navigation" (click)="navigateToForgotPassword()">Esqueceu sua senha?</a>
      </div>
    </form>

    <section class="social-media-section">
      <div class="contact-block">
        <a target="_blank" href="https://www.instagram.com/broadfactoroficial/">
          <img class="social-media" src="assets/svg/instagram.svg" alt="Instagram" />
        </a>
        <a target="_blank" href="https://www.facebook.com/broadfactoroficial">
          <img class="social-media" src="assets/svg/facebook.svg" alt="Facebook" />
        </a>
        <a target="_blank" href="https://www.linkedin.com/company/broadfactor/">
          <img class="social-media" src="assets/svg/linkedin.svg" alt="Linkedin" />
        </a>
        <a target="_blank" href="https://www.youtube.com/channel/UChxZcuH2MjPLA7ebO4VKqUA">
          <img class="social-media" src="assets/svg/youtube.svg" alt="Youtube" />
        </a>
      </div>
    </section>
  </div>
  <figure class="col-6">
    <img class="w-100" src="assets/png/capaLogin.png" alt="" />
  </figure>
</div>
